import { getContrastColor } from '@infinex/ui-utils/color';

import { envOverrides } from '../../env';
import {
  DEFAULT_CHAIN_LIMITS,
  defaultEnvironments,
  defaultServices,
  defaultSwidge,
} from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const near = {
  displayName: 'NEAR',
  runtime: 'near',
  isSupported: true,
  isReleased: false,
  isMainnet: true,
  orderPriority: 22,

  decoration: {
    color: '#00EC98',
    contrastColor: getContrastColor('#00EC98'),
  },
  features: {
    wallet: {
      supported: true,
      import: false,
    },
    vault: {
      supported: false,
      ccqRecovery: false,
    },
  },
  connectivity: {
    rpc: {
      quicknode: {
        chainKey: 'near-mainnet',
      },
    },
    blockExplorers: {
      primary: {
        base: 'https://nearblocks.io',
        token: 'https://nearblocks.io/token',
      },
    },
  },
  environments: defaultEnvironments(true),
  swidge: defaultSwidge(),
  services: defaultServices({
    coingecko: {
      networkId: 'near-protocol',
      platformId: 'near-protocol',
    },
    coingeckoDex: {
      networkId: 'near',
    },
  }),
  limits: envOverrides(DEFAULT_CHAIN_LIMITS, {}),
} as const satisfies AllChainConfig<'near', true>;
